import { apiClient } from './api'
import type { StatusReport } from './statusReport'

export interface VisibilityConfig {
  show_status: boolean
  show_milestones: boolean
  show_budget_summary: boolean
  show_flagged_risks: boolean
  /** Publish the weekly status report on the link (2026-09-28). */
  show_status_report?: boolean
}

export interface ShareLink {
  id: number
  token: string
  label?: string
  visibility_config: VisibilityConfig
  has_password: boolean
  expires_at?: string
  created_at: string
  last_accessed_at?: string
  access_count: number
  is_active: boolean
  share_url: string
}

export interface CreateShareLinkPayload {
  label?: string
  visibility_config: VisibilityConfig
  password?: string
  expires_at?: string
}

export interface PublicProjectView {
  project_name: string
  project_status?: string
  org_name?: string
  milestones?: Array<{ name: string; due_date?: string; status: string }>
  budget_summary?: { total_budget: string; currency: string }
  flagged_risks?: Array<{ title?: string; description?: string }>
  status_report?: StatusReport | null
  visibility_config: VisibilityConfig
  /** IANA display timezone for deadlines on this shared view. */
  timezone?: string
}

export const shareLinksService = {
  create: async (projectId: number, payload: CreateShareLinkPayload): Promise<ShareLink> => {
    const { data } = await apiClient.post(`/api/v1/projects/${projectId}/share-links`, payload)
    return data
  },

  list: async (projectId: number): Promise<ShareLink[]> => {
    const { data } = await apiClient.get(`/api/v1/projects/${projectId}/share-links`)
    return data
  },

  revoke: async (projectId: number, linkId: number): Promise<void> => {
    await apiClient.delete(`/api/v1/projects/${projectId}/share-links/${linkId}`)
  },

  getPublicView: async (token: string, password?: string): Promise<PublicProjectView> => {
    const { data } = await apiClient.get(`/api/v1/public/share/${token}`, {
      params: password ? { password } : {},
    })
    return data
  },
}
